/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'react';

export interface ProfileFormType {
  name: string;
  grade: number | '';
  permissionToEditTimetable: boolean;
  permissionToEditResources: boolean;
  avatar: string;
}

export type ChangeActionPayload = Partial<Record<keyof ProfileFormType, any>>;

interface ProfileAction {
  type: 'UPDATE';
  payload: ChangeActionPayload;
}

export const initialState: ProfileFormType = {
  name: '',
  grade: '',
  permissionToEditTimetable: false,
  permissionToEditResources: false,
  avatar: '',
};

export const profileReducer: Reducer<ProfileFormType, ProfileAction> = (
  state,
  { type, payload }
) => {
  switch (type) {
    case 'UPDATE': {
      return { ...state, ...payload };
    }
    default: {
      return state;
    }
  }
};
